<template>
  <main role="main">
    <core-view />
  </main>
</template>

<script>
export default {
  components: {
    CoreView: () => import('@/components/core/guest/View'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  head: {
    bodyAttrs: {
      class: 'hold-transition layout-top-nav',
    },
  },
}
</script>
